import { handlePostLogoutTasks, removeTokenDetails } from '../commands/userCommands';
import { auth } from '../data-types/initialisation/initialisationConstants';
import { setGeoLocationInfo } from '../international/internationalUtils';
import { PATHS } from '../routing-system/appPaths';
import browserHistory from '../routing-system/browserHistory';
import { trackUserLogout } from '../services/trackers';
import { logoutZendeskUser } from '../services/zendesk';
import { setIsInboxOpen } from '../state/actions/dialogActions';
import { setFromAppFlag } from '../state/actions/loginActions';
import { setCurrentSignUpPath, setHasJustSignedUp, setInitialSignUpLoad } from '../state/actions/signupActions';
import {
  clearUserDetails,
  setAuthentication,
  setInboxBadge,
  setProofRequests,
  setSaferGamblingQuestionsSetType,
  setUserAchievements,
  setUserAchievementsUpdated,
} from '../state/actions/userDataActions';
import { setUserBalance, setUserBonusWallet, setUserPaymentMethodsData, setUserTotalBalance } from '../state/actions/walletActions';
import { store } from '../state/store';
import { closeStreamIframe } from './event';
import { redirectToLogin } from './general';
import { resetPostHog, revertPostHogFeaturedFlags } from './posthog';
import { setCountrySettingsByUserLocation } from './user';
import { setXtremepushUserId } from './xtremepush';

export const performPostLogoutTasks = async (rememberPath: boolean) => {
  const {
    userData: { user },
  } = store.getState();

  setAuthentication(auth.UNAUTHENTICATED);
  clearUserDetails();
  setInitialSignUpLoad(true);
  setCurrentSignUpPath(PATHS.SIGNUP.STEPS.EMAIL);
  setUserBalance(0);
  setUserTotalBalance(0);
  setUserBonusWallet(undefined);
  removeTokenDetails();
  setFromAppFlag(false);
  revertPostHogFeaturedFlags();
  setProofRequests([]);
  setUserAchievements([]);
  setUserAchievementsUpdated(false);
  closeStreamIframe();
  await setGeoLocationInfo();
  setUserPaymentMethodsData({
    canAddNew: false,
    cards: [],
    loadingPaymentMethods: undefined,
    paymentMethodsWithNoAccounts: [],
  });
  setCountrySettingsByUserLocation();
  handlePostLogoutTasks();
  setInboxBadge(0);
  setIsInboxOpen(false);
  setXtremepushUserId(undefined);
  trackUserLogout(user && user.id);
  logoutZendeskUser();
  resetPostHog();
  setHasJustSignedUp(false);
  setSaferGamblingQuestionsSetType(undefined);

  if (window.location.pathname !== PATHS.LOGIN.ROOT) {
    if (rememberPath) {
      redirectToLogin();
      return;
    }

    browserHistory.push(PATHS.LOGIN.ROOT);
  }
};
